import { supabase } from "@/integrations/supabase/client";

const getSessionId = () => {
  let id = sessionStorage.getItem("analytics_session_id");
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem("analytics_session_id", id);
  }
  return id;
};

export type ConversionEvent =
  | "peek_preview_started"
  | "peek_locked"
  | "peek_unlock_clicked"
  | "exit_intent_shown"
  | "exit_intent_clicked"
  | "sticky_bar_clicked"
  | "sticky_bar_see_plans"
  | "banner_cta_clicked"
  | "banner_see_all_plans"
  | "fomo_toast_shown"
  | "flash_offer_shown"
  | "flash_offer_clicked"
  | "ab_test_impression"
  | "hero_cta_checkout"
  | "hero_see_all_plans"
  | "pricing_dialog_opened"
  | "pricing_plan_selected"
  | "pricing_checkout_started";

export const trackConversion = async (
  eventName: ConversionEvent,
  sectionId?: string,
  metadata?: Record<string, unknown>
) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await (supabase.from("conversion_events") as any).insert({
      event_name: eventName,
      section_id: sectionId ?? null,
      session_id: getSessionId(),
      user_id: user?.id ?? null,
      metadata: metadata ?? {},
    });
  } catch {
    // Silent fail — analytics should never break the app
  }
};
